/* unplugin-vue-components disabled */import { render } from "./DashboardUsersTab.vue?vue&type=template&id=f4037ebc&scoped=true&ts=true"
import script from "./DashboardUsersTab.vue?vue&type=script&lang=ts"
export * from "./DashboardUsersTab.vue?vue&type=script&lang=ts"

import "./DashboardUsersTab.vue?vue&type=style&index=0&id=f4037ebc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4037ebc"]])

export default __exports__